@if (subcategories().length > 0) {
<div class="subcat-carousel">
  <div class="subcat-carousel__wrapper">
    @if (canScrollLeft() || canScrollRight()) {
      <button
        class="subcat-carousel__arrow subcat-carousel__arrow--prev"
        type="button"
        aria-label="Anterior"
        (click)="scrollPrev()"
      >
        <app-icon [icon]="chevronLeft" [size]="16" />
      </button>
    }

    <div class="subcat-carousel__track" #track>
      @for (sub of subcategories(); track sub.slug) {
        <a
          class="subcat-carousel__item"
          [routerLink]="sub.link"
        >
          <div class="subcat-carousel__image-wrap">
            <img
              class="subcat-carousel__image"
              [src]="sub.image"
              [alt]="sub.name"
              loading="lazy"
            />
          </div>
          <div class="subcat-carousel__info">
            <span class="subcat-carousel__name">{{ sub.name }}</span>
            @if (sub.productCount) {
              <span class="subcat-carousel__count">{{ sub.productCount }} productos</span>
            }
          </div>
        </a>
      }
    </div>

    @if (canScrollLeft() || canScrollRight()) {
      <button
        class="subcat-carousel__arrow subcat-carousel__arrow--next"
        type="button"
        aria-label="Siguiente"
        (click)="scrollNext()"
      >
        <app-icon [icon]="chevronRight" [size]="16" />
      </button>
    }
  </div>
</div>
}
